(() => {
  const main = document.querySelector('#MainContent');
  if (!main || main.querySelector('.niso-v2-support')) return;
  const template = main.dataset.template || '';
  const starts = (name) => template === name || template.startsWith(`${name}.`);
  // Product, collection and cart now contain native NISO support/discovery sections.
  if (starts('product') || starts('collection') || starts('cart')) return;
  let eyebrow = '';
  let heading = '';
  let content = '';
  const chip = (href, title) => `<a class="niso-v2-support__chip" href="${href}">${title}</a>`;
  if (starts('search') || starts('404')) {
    eyebrow = 'Keep exploring';
    heading = 'More ways into NISO';
    content = `<div class="niso-v2-support__chips">${chip('/collections/new-arrivals','New Arrivals')}${chip('/collections/everyday','Everyday')}${chip('/collections/festive','Festive')}${chip('/collections/bridal','Bridal')}${chip('/collections/idols','Silver Idols')}${chip('/pages/gifting','Gifting')}</div>`;
  } else if (starts('page')) {
    eyebrow = 'More from NISO';
    heading = 'Keep learning or keep shopping';
    content = `<div class="niso-v2-support__chips">${chip('/pages/about-niso','About NISO')}${chip('/pages/why-925-silver','Why 925 Silver')}${chip('/pages/jewellery-care','Jewellery Care')}${chip('/pages/ring-size-guide','Ring Size Guide')}${chip('/pages/faq','FAQ')}${chip('/collections/new-arrivals','Shop New Arrivals')}</div>`;
  }
  if (!content) return;
  const html = `<section class="niso-v2-support"><div class="niso-v2-support__inner"><header class="niso-v2-support__head"><div><p class="eyebrow">${eyebrow}</p><h2>${heading}</h2></div></header>${content}</div></section>`;
  main.insertAdjacentHTML('beforeend', html);
})();